import { ajaxJson, ajaxFD } from 'imports/ajax';
import { createTypes } from 'redux-create-types';
import {
    map2UserObj,
    map2Attachment
} from 'imports/mapper';
import { userActionCreators } from 'db/user/user.action';
import { attachmentActionsCreators } from 'db/attachment/attachment.action';
import * as auth from 'imports/auth';
import * as axios from 'axios';
import { toast } from 'react-toastify';
import * as moment from 'moment-jalaali';


const namespace = 'profile';

export const profileActions = createTypes([
    'toggleSpinner',
    'setError',
    'setUploadDocumentCancelToken',
], namespace);

function showSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: profileActions.toggleSpinner,
            payload: true,
            meta: {apiName}
        });
    }
}

function hideSpinner(apiName) {
    return dispatch => {
        dispatch({
            type: profileActions.toggleSpinner,
            payload: false,
            meta: {apiName}
        });
    }
}

function makeUserLogin(user, token) {
    return dispatch => {
        auth.login({
            token,
            ...user
        });
    }
}

function getAttachmentStatusApiSuccess(res) {
    return dispatch => {
        const attachmentObjects = res.data.map(attachment => {
            return map2Attachment(attachment);
        });
        dispatch(userActionCreators.setAttachments(attachmentObjects));
        dispatch(hideSpinner('attachment-status'));
    }
}

function getAttachmentStatusApiFail(err) {
    return dispatch => {
        dispatch({
            type: profileActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('attachment-status'));
    }
}

function getAttachmentStatusFromApi() {
    return dispatch => {
        dispatch(showSpinner('attachment-status'));
        return ajaxJson.get('/users/attachments/status')
        .then(
            res => dispatch(getAttachmentStatusApiSuccess(res)),
            err => dispatch(getAttachmentStatusApiFail(err)),
        )
    }
}

function getUserApiSuccess(res) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        dispatch(userActionCreators.set(userObj));
        dispatch(makeUserLogin(userObj, res.data['access_token']))
        dispatch(getAttachmentStatusFromApi())
        .then(() => {
            return dispatch(hideSpinner('user'));
        });
    }
}

function getUserApiFail(err) {
    return dispatch => {
        dispatch({
            type: profileActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('user'));
    }
}

function getUserFromApi() {
    return dispatch => {
        dispatch(showSpinner('user'));
        return ajaxJson.get('/users')
        .then(
            res => dispatch(getUserApiSuccess(res)),    
            err => dispatch(getUserApiFail(err)),    
        )
    }
}

function patchUserApiFail(err, formActions, birthday) {
    return dispatch => {
        if (err.response && err.response.status === 400) {
            const birthdayMoment = moment(new Date(birthday));
            let birthdayError = (err.response.data["birthday_date"] || null);
            if (birthdayError === null && birthdayMoment && !birthdayMoment.isValid()) {
                birthdayError = 'تاریخ نا معتبر است.'
            }
            formActions.setErrors({
                firstName: err.response.data["first_name"] || null,
                lastName: err.response.data["last_name"] || null,
                email: err.response.data["email"] || null,
                major: err.response.data["major"] || null,
                address: err.response.data["address"] || null,
                biography: err.response.data["biography"] || null,
                birthday: birthdayError,
                educationDegree: err.response.data["education_degree"] || null,
                linkedinUrl: err.response.data["linkedin_url"] || null,
                postalCode: err.response.data["postal_code"] || null,
                university: err.response.data["university"] || null,
                jobTitle: err.response.data["job_title"] || null,
                jobPosition: err.response.data["occupational_field"] || null,
            });
        }
        formActions.setSubmitting(false);
        dispatch({
            type: profileActions.setError,
            payload: err,
        })
        return dispatch(hideSpinner('update-user'));
    }
}

function patchUserApiSuccess(res, formActions) {
    return dispatch => {
        formActions.setSubmitting(false);
        toast.success('اطلاعات شما با موفقیت ذخیره شد.')
        return dispatch(hideSpinner('update-user'));
    }
}

function patchUserToApi(user, formActions) {
    return dispatch => {
        dispatch(showSpinner('update-user'));
        const bodyData = {
            "first_name": user.firstName,
            "last_name": user.lastName,
            "email": user.email,
            "address": user.address,
            "education_degree": user.educationDegree,
            "major": user.major,
            "university": user.university,
            "birthday_date": user.birthday,
            "postal_code": user.postalCode,
            "job_title": user.jobTitle,
            "occupational_field": user.jobPosition,
            "biography": user.biography,
            "linkedin_url": user.linkedinUrl,
        }
        return ajaxJson.patch('/users', bodyData).then(
            res => dispatch(patchUserApiSuccess(res, formActions)),
            err => dispatch(patchUserApiFail(err, formActions, user.birthday)),
        )
    }
}

function uploadDocumentApiSuccess(res, id) {
    return dispatch => {
        const dispatch1 = dispatch(attachmentActionsCreators.setFilePath(id, res.data["file"]));
        const dispatch2 = dispatch(attachmentActionsCreators.cleanUploadingProgress(id));
        const dispatch3 = dispatch(attachmentActionsCreators.setStatusUploaded(id));  
        return Promise.all([dispatch1, dispatch2, dispatch3]);
    }
}

function uploadDocumentApiFail(err, id) {
    return dispatch => {
        const dispatch1 = dispatch(attachmentActionsCreators.cleanUploadingProgress(id));
        const dispatch2 = dispatch(attachmentActionsCreators.setStatusError(id));
        dispatch({
            type: profileActions.setError,
            payload: err,
        });
        
        return Promise.all([dispatch1, dispatch2]).then(() => {
            return dispatch(hideSpinner('upload-document'));
        })
    }
}

function updateUploadingDocumentProgress(progressEvent, id) {
    return dispatch => {
        const progress = Math.trunc((progressEvent.loaded / progressEvent.total) * 100);
        dispatch(attachmentActionsCreators.setUploadingProgress(id, progress));
    }
}

function uploadDocumentToApi(formData, id) {
    return dispatch => {
        const cancelTokenSource = axios.CancelToken.source();        
        dispatch({
            type: profileActions.setUploadDocumentCancelToken,
            payload: {
                cancelTokenSource,
                id,
            }
        })
        const ajaxConfig = {
            onUploadProgress: (progressEvent) => {
                dispatch(updateUploadingDocumentProgress(progressEvent, id));
            },
            cancelToken: cancelTokenSource.token,
        };
        dispatch(attachmentActionsCreators.setStatusUploading(id));  
        return ajaxFD.post(`/users/attachments`, formData, ajaxConfig)
        .then(
            res => dispatch(uploadDocumentApiSuccess(res, id)),
            err => dispatch(uploadDocumentApiFail(err, id)),
        )
    }
}

function uploadDocument(id, file) {
    return dispatch => {
        dispatch(showSpinner('upload-document'));
        const formData = new FormData();
        formData.append('attachment_title_uid', id);
        formData.append('file', file);
        dispatch(uploadDocumentToApi(formData, id, file));
    }
}

function uploadPictureApiSuccess(res) {
    return dispatch => {
        const userObj = map2UserObj(res.data);
        dispatch(userActionCreators.updateUserPicture(userObj.image));
        const currentUserData = auth.getUser(); 
        auth.login({
            token: currentUserData.token,
            ...userObj
        });
    }
}

function uploadPictureApiFail(err) {
    return dispatch => {
        dispatch({
            type: profileActions.setError,
            payload: err,
            meta: {
                apiName: 'upload-user-picture'
            }
        })
        return dispatch(hideSpinner('upload-user-picture'));
    }
}

function uploadPictureToApi(formData) {
    return dispatch => {
        dispatch(showSpinner('upload-user-picture'))
        return ajaxFD.put('/users/image', formData)
        .then(
            res => dispatch(uploadPictureApiSuccess(res)),
            err => dispatch(uploadPictureApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('upload-user-picture'));
        })
    }
}

function uploadPicture(file) {
    return dispatch => {
        dispatch(showSpinner('upload-picture'));
        const formData = new FormData();
        formData.append('image', file);
        return dispatch(uploadPictureToApi(formData));
    }
}

function cancelUploadingDocument(id) {
    return (dispatch, getState) => {
        const cancelTokens = getState().ui.profilePage.cancelTokens[id]
        if (cancelTokens) {
            cancelTokens.cancel('انصراف از آپلود.');
        }
    }
}

function changeEmailApiSuccess(res) {
    return dispatch => {
        dispatch(userActionCreators.changeEmail(res.data['email']));
    }
}

function changeEmailApiFail(err) {
    return dispatch => {
        dispatch({
            type: profileActions.setError,
            payload: err,
            meta: {
                apiName: 'change-email'
            }
        })
        return dispatch(hideSpinner('change-email'));
    }
}

function changeEmail(email) {
    return dispatch => {
        dispatch(showSpinner('change-email'))
        return ajaxJson.post('/users/change_email', {
            email
        })
        .then(
            res => dispatch(changeEmailApiSuccess(res)),
            err => dispatch(changeEmailApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('change-email'));
        });  
    }
}

function sendConfirmationLinkApiSuccess(res) {
    return dispatch => {
        toast.success('لینک تایید به شما ایمیل شد.')
    }
}

function sendConfirmationLinkApiFail(err) {
    return dispatch => {
        dispatch({
            type: profileActions.setError,
            payload: err,
            meta: {
                apiName: 'send-verification-link'
            }
        })
        return dispatch(hideSpinner('send-verification-link'));
    }
}

function sendConfirmationLink() {
    return dispatch => {
        dispatch(showSpinner('send-verification-link'))
        return ajaxJson.post('/users/email/verification/resend')
        .then(
            res => dispatch(sendConfirmationLinkApiSuccess(res)),
            err => dispatch(sendConfirmationLinkApiFail(err)),
        ).then(() => {
            return dispatch(hideSpinner('send-verification-link'));
        });
    }
}

export const profileActionCreators = {
    getUserFromApi,
    patchUserToApi,
    uploadDocument,
    cancelUploadingDocument,
    uploadPicture,
    changeEmail,
    sendConfirmationLink
}